




















import { Box, SocialButton, SocialIcon, Flex } from '../../atoms'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { DEFAULT_SOCIAL_DISPLAYNAME } from '@/constant/social'

@Component({
  components: {
    Box,
    SocialButton,
    SocialIcon,
    Flex
  }
})
export default class SocialConfirmBox extends Vue {
  @Prop({ required: true, type: String }) readonly social!: string
  @Prop({ type: String, default: '' }) readonly displayName?: string
  @Prop({ type: String, default: '' }) readonly dataAction?: string
  @Prop({ type: String, default: '' }) readonly dataFnAction?: string
  get getSocialDisplayName(): string {
    if(this.displayName) {
      return this.displayName
    }
    return (DEFAULT_SOCIAL_DISPLAYNAME)(this.social)
  }
}
